import React, { Component } from 'react'
import imgs from '../../assets/images/webinarhead.png'
import './css/joinwebinar.css'
import vidpic from "../../assets/images/Vid1.png"

class joinwebinar extends Component {
    render() {
        return (
            <div className="joinwebinar">
                <dic className="joinwebinarfield">
                    <div className="joinwebinarimage">
                        <img src={imgs} alt="webinarimages"/>
                        <img src={vidpic} alt="webinarimages" className="margedpic"/>
                    </div>
                    <div className="joinwebinartext">
                        <h2>
                        Join daily & weekly live <br/>sessions with our educators.
                        </h2>
                        <p>
                        -Stay Updated on the dynamic shifts in the forex market and cryptocurrency market inclusively. <br /> <br /> -Analysis on specific currency, stock, indices, commodity, etc
                        </p>
                    </div>
                </dic>
            </div>  
        )
    }
}

export default joinwebinar;